import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const AttendanceDuty = Loadable(lazy(() => import('./AttendanceDuty/AttendanceDuty')));

const attendanceDutyRoutes = [
    { path: '/employee/attendance-duties',      element: <AttendanceDuty />, auth: authRoles.admin },
    { path: '/employee/attendance-duties/:id',  element: <AttendanceDuty />, auth: authRoles.admin },
];

export default attendanceDutyRoutes;
